@if (showSmartBundleInsights(personaReport)) {
  <div class="persona-container">
    <h3 class="smart-bundle-heading">
      <strong>Enhance your initial quote with a <i>Protector</i> package</strong>
    </h3>
    <div class="smart-bundle-subheading">
      Protectors are individuals who understand the value of insurance and are not
      just focused on price. Consider these coverages to safeguard their lifestyle
      which can be modified as needed.
    </div>
    <hr />
    <ng-container *ngTemplateOutlet="persona"></ng-container>
    <ng-container *ngTemplateOutlet="options"></ng-container>
    @if (errorMessage$ | async; as message) {
      <nwx-notification-bubble
        type="error"
        >{{ message }}</nwx-notification-bubble
        >
      }
    </div>
  }

  <ng-template #persona>
    <div class="subsection-header">
      Choose <i>Protector</i> coverages that fit your customer's life stage.
    </div>
    <nwx-carousel [items]="enabledPersonaChoices">
      <ng-template let-item>
        <div
          class="persona-name"
          [ngClass]="{ selected: personaReport?.name === item.name }"
          (click)="onChoosePersona(item.name, $event)"
          >
          {{ item.label }}
        </div>
      </ng-template>
    </nwx-carousel>
  </ng-template>

  <ng-template #options>
    <div class="persona-inner-container">
      <div class="bolt-container-fluid">
        <div class="bolt-row">
          <div class="bolt-col-12">
            {{ selectedPersonaDescription() }}
          </div>
        </div>
        <div class="bolt-row">
          @for (product of products; track product) {
            <div class="bolt-col-12 bolt-col-lg-4">
              <div
                class="bolt-row bolt-align-items-end bolt-space-bottom-sm header-row"
                >
                <div class="bolt-col-8">
                  <h5 class="bolt-subheading-lg">
                    <strong>{{ product.length > 0 ? product : 'More' }}</strong>
                  </h5>
                </div>
                @if (getProductIconName(product).length > 0) {
                  <div class="bolt-col-4 no-left-padding product-header-icon">
                    <img
                      [src]="'/assets/images/icons/' + getProductIconName(product)"
                      role="presentation"
                      />
                    </div>
                  } @else {
                    <div class="bolt-col-4 no-left-padding"></div>
                  }
                </div>
                @if (getProductRecommendations(product).length > 0) {
                  @for (recommendation of getProductRecommendations(product); track recommendation.id) {
                    <div
                      class="bolt-row recommendation-row"
                      >
                      <div class="bolt-col-auto">
                        @if (!recommendation.present) {
                          @if (
                            getRecommendationDisplayDetails(
                            recommendation.id
                            )?.icon?.includes('.svg')) {
                            <img
                      [src]="
                        '/assets/images/icons/' +
                        getRecommendationDisplayDetails(recommendation.id)?.icon
                      "
                              role="presentation"
                              class="tile-img"
                              />
                            } @else {
                              <bolt-icon
                      [name]="
                        getRecommendationDisplayDetails(recommendation.id)?.icon
                      "
                                color="vibrantBlue"
                              ></bolt-icon>
                            }
                          } @else {
                            <bolt-icon
                              name="checkmark-circle-filled"
                              color="vibrantBlue"
                              decorative
                              class="float-left"
                            ></bolt-icon>
                          }
                        </div>
                        <div class="bolt-col no-left-padding normal-line-height">
                          {{ getRecommendationDisplayDetails(recommendation.id)?.label }}
                        </div>
                        <div class="bolt-col-4 no-left-padding text-center">
                          @if (!recommendation.present) {
                            @if (
                              !recommendationInFlight(recommendation.id)) {
                              <bolt-button
                                size="sm"
                                arialabel="Add option"
                                [attr.id]="'add-button-' + recommendation.id"
                                (click)="addRecommendation(recommendation)"
                                >Add</bolt-button
                                >
                            } @else {
                              <bolt-waiting-indicator
                                [attr.id]="'add-spinner-' + recommendation.id"
                                minimal
                              ></bolt-waiting-indicator>
                            }
                          } @else {
                            @if (
                              !recommendationInFlight(recommendation.id)) {
                              <bolt-button
                                type="ghost"
                                size="sm"
                                arialabel="Remove option"
                                [attr.id]="'remove-button-' + recommendation.id"
                                (click)="removeRecommendation(recommendation)"
                                >Remove</bolt-button
                                >
                              } @else {
                                <bolt-waiting-indicator
                                  [attr.id]="'remove-spinner-' + recommendation.id"
                                  minimal
                                ></bolt-waiting-indicator>
                              }
                            }
                          </div>
                        </div>
                      }
                    }
                  </div>
                }
              </div>
              <!-- <div class="bolt-row">
              <div class="bolt-col">
                <bolt-button
                  type="solid"
                  arialabel="Add all options"
                  id="add-all-recommendations"
                  class="float-right"
                  [attr.disabled]="areAllRecommendationsSelected() ? true : null"
                  (click)="addAllRecommendations()"
                  >Add all options</bolt-button
                  >
                </div>
              </div> -->
            </div>
          </div>
          <div class="d-flex justify-content-start align-items-center mt-3">
            <bolt-button
              class="help-button"
              type="ghost"
              color="vibrantBlue"
              (click)="displayHelpModal()"
              iconleft="question-circle"
              >
              <span>Learn more about these coverages</span>
            </bolt-button>
          </div>
        </ng-template>
